import inventoryService from '@/services/api/inventory.services'

const actions = {
    getInventory() {
        return new Promise((resolve, reject) => {
            inventoryService
                .get('inventory')
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createEquipment(content, data) {
        return new Promise((resolve, reject) => {
            inventoryService
                .post('inventory', data.payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    updateEquipment(content, data) {
        return new Promise((resolve, reject) => {
            inventoryService
                .put('inventory', data.id, data.payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteEquipment(context, id) {
        return new Promise((resolve, reject) => {
            inventoryService
                .delete('inventory', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getInventoryCategories() {
        return new Promise((resolve, reject) => {
            inventoryService
                .get('categories')
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

export default {
    namespaced: true,
    actions,
}
